// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { vmiLocationsImportModalStyles } from "@vanmeter/Overrides/Components/VmiLocationsImportModal";
import { fontConfig } from "@vanmeter/XDL/constants";
import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiLocationsImportModalStyles.instructionText = {};

vmiLocationsImportModalStyles.templateLink = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
};

vmiLocationsImportModalStyles.cancelUploadButton = {
    ...modalButtonsActionStyles.cancelButton,
};

vmiLocationsImportModalStyles.returnToVmiLocationsButton = {
    ...modalButtonsActionStyles.submitButton,
};

vmiLocationsImportModalStyles.instructionGridItem = { width: 12 };

vmiLocationsImportModalStyles.uploadInputGridItem = {
    width: 12,
    css: css`
        order: 2;
    `,
};

vmiLocationsImportModalStyles.fileUploader = {
    mergeCss: true,
    buttonProps: {
        variant: "secondary",
    },
};

vmiLocationsImportModalStyles.controlsGridItem = {
    width: 12,
    css: css`
        display: block;
        padding: 0;
    `,
};

vmiLocationsImportModalStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                gap: 12px;
                > button {
                    width: 100%;
                }
            }
        `,
    }),
};
